import { FILE_STATUS } from '@/components/FileUpload/common/constants';
import { ExtendedUploadFile } from '@/components/FileUpload/common/types';
import { SKIP_CREDIT_CALCULATION } from '@/components/ModelForm/creditTransform';

const isUploadedReferenceVideo = (file: ExtendedUploadFile | undefined) =>
  file?.status === FILE_STATUS.SUCCESS && Boolean(file.url);

export const transformSeedanceReferenceVideosForCredit = (value: unknown) => {
  const referenceVideos = value as ExtendedUploadFile[] | undefined;

  if (!Array.isArray(referenceVideos) || referenceVideos.length === 0) {
    return undefined;
  }

  const uploadedReferenceVideos = referenceVideos.filter(isUploadedReferenceVideo);

  if (uploadedReferenceVideos.length === 0) {
    return SKIP_CREDIT_CALCULATION;
  }

  return uploadedReferenceVideos
    .map((file) => file.url)
    .filter((url): url is string => Boolean(url));
};
